export const checkImageUrl = (url = '') =>
  url.match(/\.(jpeg|jpg|gif|png)$/) != null;
